import { Moment } from 'moment';
import { IBusiness } from './business.interface';
import { IServiceProvider } from './team/serviceProvider.interface';
import { IService } from './service.interface';
import { ICustomer } from './customer.interface';

export interface IWaitlist {
    _id: string;
    business: IBusiness | string;
    service_provider?: IServiceProvider | string;
    service: IService | string;
    customer: ICustomer | string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    preferred_date_time: Moment;
    preferred_range: PreferredRangeEnum;
    note: string;
    created_at: Date;
    updated_at: Date;
}

export enum PreferredRangeEnum {
    MORNING = 'morning',
    AFTERNOON = 'afternoon',
    EVENING = 'evening',
}

export interface ICreateWaitlistEntry {
    businessId: string;
    serviceProviderId?: string;
    serviceId: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    preferredDateTime: Date;
    preferredRange: PreferredRangeEnum;
    note: string;

    // Ad-tracking stuff
    conversionTracking?: {
        utm_source?: string;
        utm_medium?: string;
        utm_campaign?: string;
        utm_term?: string;
        utm_content?: string;
        gclid?: string;
    };
}
